<main>
  <loading-overlay [isLoading]="isLoading() > 0" />
  <header>
    <div class="headline">
      <h1>
        {{ 'CodeCreationDetail.Title' | translateWF: 'Code Creation Request' }}
      </h1>
    </div>
    <div class="buttons">
      @if (canEdit()) {
        @if (currentItemMasterRequest()) {
          <p-button
            [ngClass]="{
              hidden: !isAdminCodeCreation(),
            }"
            label="Create"
            icon="pi pi-plus"
            (onClick)="openModalCreateItemMasterRequest()"
          />
        } @else {
          <p-button label="Save" icon="pi pi-plus" (onClick)="onSave()" [disabled]="!canEdit()" />
        }
      }
      <p-button label="Cancel" variant="outlined" (onClick)="onCancel()" />
    </div>
  </header>

  <div class="content">
    <!-- !general information -->
    <p-panel [header]="'CodeCreationDetail.GeneralInformation' | translateWF: 'General Information'">
      <p-card>
        <div class="grid-auto-4">
          <div class="form-box">
            <label>
              {{ 'CodeCreationDetail.Company' | translateWF: 'Company' }}
            </label>
            <p-autocomplete [formControl]="company" optionLabel="name" class="w-full" styleClass="w-full" inputStyleClass="w-full" />
          </div>
          <div class="form-box">
            <label>
              {{ 'CodeCreationDetail.InventoryType' | translateWF: 'Inventory Type' }}
            </label>
            <p-select [options]="inventoryTypeOptionsForSelect" [formControl]="inventoryTypeReference" />
          </div>
        </div>
      </p-card>
    </p-panel>

    <!-- !Item Details -->
    <p-panel [header]="'CodeCreationDetail.ItemDetails' | translateWF: 'Item Details'">
      <p-card>
        <div class="grid-2 row-auto gap-5 mt-5">
          <div class="col-sm">
            <label>
              {{ 'CodeCreationDetail.Description' | translateWF: 'Description' }}
            </label>
            <input type="text" pInputText [formControl]="itemDescription" />
          </div>

          <div class="col-sm">
            <label>
              {{ 'CodeCreationDetail.ManufacturerBrand' | translateWF: 'Manufacturer/Brand' }}
            </label>
            <input type="text" pInputText [formControl]="manufacturer" />
          </div>

          @if (showPartsAndAssets()) {
            <div class="col-sm">
              <label>
                {{ 'CodeCreationDetail.NumberOfPart' | translateWF: 'Number of Part' }}
              </label>
              <input type="text" pInputText [formControl]="manufacturerPartIdentifier" />
            </div>

            <div class="col-sm">
              <label>
                {{ 'CodeCreationDetail.TypeAsset' | translateWF: 'Type Asset' }}
              </label>
              <p-select [options]="assetTypeOptions()" [formControl]="assetTypeReference" optionLabel="name" optionValue="id" />
            </div>
          }

          <div class="col-sm">
            <label>
              {{ 'CodeCreationDetail.UnitOfMeasure' | translateWF: 'Unit of Measure' }}
            </label>
            <p-select [options]="uomsOptions()!" [formControl]="mainUom" />
          </div>

          <div class="span-2 col-sm">
            <label for="">
              {{ 'CodeCreationDetail.SpecialFeatures' | translateWF: 'Special Features of the Item' }}
            </label>
            <textarea rows="5" cols="50" pTextarea [formControl]="characteristics"></textarea>
          </div>

          <div class="span-2 col-sm">
            <label for="">
              {{ 'CodeCreationDetail.AdditionalInformation' | translateWF: 'Additional Information' }}
            </label>
            <textarea rows="5" cols="50" pTextarea [formControl]="extraComments"></textarea>
          </div>
        </div>
      </p-card>
    </p-panel>

    <!-- !Alternative Units of Measure -->
    <p-panel [header]="'CodeCreationDetail.AlternativeUnitsOfMeasure' | translateWF: 'Alternative Units of Measure'">
      <p-card>
        <div class="grid-3 row-auto gap-5 mt-5">
          <div class="span-2 row-sm-start-center">
            <div class="col-sm w-full">
              <label>
                {{ 'CodeCreationDetail.BaseUnitOfMeasure' | translateWF: 'Base Unit of Measure' }}
              </label>
              <p-inputgroup>
                <p-inputnumber class="w-full" styleClass="w-full" [formControl]="baseRate" [disabled]="mainUom.value === null || !canEdit()" [min]="0" />
                <p-inputgroup-addon>
                  {{ currentUomSelected() | uppercase }}
                </p-inputgroup-addon>
              </p-inputgroup>
            </div>
            <p class="text-xl font-bold mt-5">=</p>

            <div class="col-sm w-full">
              <label>
                {{ 'CodeCreationDetail.Conversion' | translateWF: 'Conversion' }}
              </label>
              <p-inputnumber class="w-full" styleClass="w-full" [formControl]="conversionRate" [min]="0" />
            </div>
          </div>

          <div class="col-sm">
            <label>
              {{ 'CodeCreationDetail.AlternativeUnitsOfMeasure' | translateWF: 'Alternative Units of Measure' }}
            </label>
            <p-select [formControl]="uom" [options]="uomsOptions()" />
          </div>
        </div>
      </p-card>
    </p-panel>

    <!-- !Request -->
    <p-panel [header]="'CodeCreationDetail.Request' | translateWF: 'Request'">
      <p-card>
        <div class="grid-3 mt-5">
          <div class="col-sm">
            <label>
              {{ 'CodeCreationDetail.Priority' | translateWF: 'Priority' }}
            </label>
            <p-select [formControl]="priority" [options]="priorityOptions()" />
          </div>
          <div class="col-sm">
            <label>
              {{ 'CodeCreationDetail.RequestersArea' | translateWF: "Requester's Area" }}
            </label>
            <p-select [formControl]="departmentReference" [options]="departmentOptionsForSelect" />
          </div>
          <div class="col-sm">
            <label>
              {{ 'CodeCreationDetail.RequesterName' | translateWF: 'Requester Name' }}
            </label>
            <input type="text" pInputText [formControl]="requester" />
          </div>
        </div>
      </p-card>
    </p-panel>
  </div>
</main>
